import { Avatar, FormHelperText, Stack, styled } from "@mui/material";
import React, { useRef } from "react";
import UploadImage from "../../assets/images/upload-image.png";
import { handleOpenSnackBar } from "../../utils/helper";
import axios from "axios";

const ImageUploader = ({ isError, image, setImage, setIsLoading }) => {
  const imgRef = useRef(null);

  const handleChangeImage = async (event) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("image", event.target.files[0]);
      const response = await axios({
        method: "post",
        url: "https://sirldigital.com/uploadService.php",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      setImage(response?.data?.url);
      handleOpenSnackBar("success", response?.data?.message);
      imgRef.current.value = null;
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: theme.spacing(16),
    height: theme.spacing(16),
    boxShadow: theme.shadows[2],
    border: `1px solid ${isError ? "red" : "white"}`,
    backgroundColor: theme.palette.background.paper,
    padding: image ? theme.spacing(2) : theme.spacing(3),
    cursor: "pointer",
  }));

  return (
    <Stack alignItems={"center"}>
      <StyledAvatar
        alt="Profile Image"
        src={image || UploadImage}
        onClick={() => imgRef.current.click()}
      />
      <FormHelperText sx={{ color: isError && "red" }}>
        {image ? "Edit Image" : "Upload Image"}
      </FormHelperText>
      <input
        type="file"
        ref={imgRef}
        style={{ display: "none" }}
        onChange={handleChangeImage}
      />
    </Stack>
  );
};

export default ImageUploader;
